(function () {
  const menuButton = document.querySelector(".menu__li--have-children");
  if (!menuButton) return;

  const megaMenu = menuButton.querySelector(".menu__mega");
  if (!megaMenu) return;

  let closeTimer = null;
  const isDesktopHover = window.matchMedia(
    "(hover: hover) and (pointer: fine)",
  ).matches;

  function openMenu() {
    clearTimeout(closeTimer);
    menuButton.classList.add("is-open");
  }

  function closeMenu() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      menuButton.classList.remove("is-open");
    }, 80);
  }

  function toggleMenu(e) {
    e.preventDefault();
    e.stopPropagation();
    menuButton.classList.contains("is-open") ? closeMenu() : openMenu();
  }

  const trigger = menuButton.querySelector(".menu__link");

  if (trigger) {
    trigger.addEventListener("click", toggleMenu);
  }

  document.addEventListener("click", function (e) {
    if (!menuButton.contains(e.target)) {
      menuButton.classList.remove("is-open");
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      menuButton.classList.remove("is-open");
    }
  });

  if (isDesktopHover) {
    menuButton.addEventListener("mouseenter", openMenu);
    menuButton.addEventListener("mouseleave", closeMenu);
  }
})();
